import type { FinancialDataTableColumn } from '@/components/organisms';
import {
  toCustomFieldColumnKey,
  type CustomFieldColumnKey,
} from '@/components/organisms/custom-fields/custom-field-table-utils';
import type { CustomFieldSchema } from '@/types/custom-fields';

export function buildCustomFieldColumns<
  TKey extends string,
  TColumn extends FinancialDataTableColumn<TKey> = FinancialDataTableColumn<TKey>,
>(
  schemas: CustomFieldSchema[],
  extraColumnProps: Omit<Partial<TColumn>, 'key' | 'label' | 'defaultVisible'> = {} as Omit<
    Partial<TColumn>,
    'key' | 'label' | 'defaultVisible'
  >,
): TColumn[] {
  return schemas.map(
    (schema) =>
      ({
        key: toCustomFieldColumnKey(schema.definition.id) as CustomFieldColumnKey & TKey,
        label: schema.definition.label,
        defaultVisible: false,
        ...extraColumnProps,
      }) as TColumn,
  );
}
